import Icon from '../components/Icon.vue'

Icon.register({
  school: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M0 224c0-17.7 14.3-32 32-32h64v320h-80c-8.8 0-16-7.2-16-16v-272zM360 176c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-64c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v40h24zM497.8 112c8.9 5.9 14.3 15.9 14.3 26.6v373.3h-128v-144c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v144h-128v-373.3c0-9.5 6.4-21.4 14.3-26.6l160-106.7c4.5-3 12.4-5.4 17.8-5.4s13.3 2.4 17.8 5.4zM320 256c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zM608 192c17.7 0 32 14.3 32 32v272c0 8.8-7.2 16-16 16h-80v-320h64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/school.js
// module id = 1863
// module chunks = 0